import { DateTimeFormatOptions } from "luxon";
import { capitalize } from "@mui/material";

/**
 * Convert Intl format setting to luxon format setting, used for correctly set formatting with localisation for date inputs
 * @deprecated
 */
export const intlToLuxonFormat = <TOptionsKey extends keyof DateTimeFormatOptions = keyof DateTimeFormatOptions>(
  locale: string,
  options: { [key in TOptionsKey]: DateTimeFormatOptions[TOptionsKey] },
  mapper: Record<TOptionsKey, string>
) => {
  const parts = new Intl.DateTimeFormat(locale ?? "en-GB", options).formatToParts(0);
  const format: string[] = [];
  parts.forEach((item) => {
    if (Object.prototype.hasOwnProperty.call(mapper, item.type)) {
      format.push(mapper[item.type.toString() as TOptionsKey]);
    }
    if (item.type === "literal") {
      const valueToBePushed = item.value.match(/^[ :,.]+$/g) ? item.value : `'${item.value}'`;
      format.push(valueToBePushed);
    }
  });

  return format.join("");
};

export const getWeekdayName = (dayNumber: number, locale: string, format: "long" | "short" | "narrow" = "long") => {
  // JavaScript Date uses 0-6 for days (Sunday-Saturday)
  const date = new Date();
  date.setDate(date.getDate() - date.getDay() + (dayNumber === 7 ? 0 : dayNumber));

  return capitalize(new Intl.DateTimeFormat(locale, { weekday: format }).format(date));
};
